import React, { useCallback } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'react-toastify';
import { useCreateChecklist } from '@area-restrita/api-client/endpoints/hang-tag/hang-tag.gen';

import { ICheckList } from '../../components/CheckListForm/schema';
import NewCheckListView from './view';

const NewCheckList: React.FC = () => {
  const navigate = useNavigate();

  const createChecklist = useCreateChecklist({
    mutation: {
      onSuccess: () => {
        toast.success('Checklist criado com sucesso');
        navigate({ to: '/settings/hang-tag/check-list' });
      },
      onError: () => {
        toast.error('Erro ao criar checklist');
      },
    },
  });

  const handleSubmit = useCallback<SubmitHandler<ICheckList>>(
    (data) => createChecklist.mutateAsync({ data }),
    [createChecklist],
  );

  return <NewCheckListView onSubmit={handleSubmit} />;
};

export default NewCheckList;
